import { Component, ViewEncapsulation, inject } from '@angular/core';

import { LoadingOverlayService } from './loading-overlay.service';

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoadingOverlayComponent {
    private readonly loadingOverlayService = inject(LoadingOverlayService);

    public readonly loading$ = this.loadingOverlayService.loading$;
}
